module.exports = __webpack_public_path__ + "media/components/riskregister/icon-vectors/facilities-08d3f47c11825f7ee1925b3d6188ef50.png";